import BaseApiRequest from "./BaseApiRequest";
import { RECOVERPASSWORD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
class ForgotPasswordRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  constructor(userDetail) {
    super();
    this.body = userDetail;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(RECOVERPASSWORD_URL);

  getBody = () => this.body;
}

export default ForgotPasswordRequest;
